export const GET_AUTH_REQUEST = "GET_AUTH_REUEST";
export const GET_AUTH_SUCCESS = "GET_AUTH_SUCCESS";
export const GET_AUTH_FAILURE = "GET_AUTH_FAILURE";
export const GET_AUTH_LOGOUT = "GET_AUTH_LOGOUT";
